export const userRoles = {
  SUPER_ADMIN: 1,
  ADMIN: 2,
};
